<div
	class="d-flex"
	style="padding: 8px min(4px, 2svw); max-width: 992px; margin: auto"
>
	@if (dataObj?.logo) {
		<img
			[src]="
				dataObj?.logo
					? environment.serverUrl +
						'/user-logo?fdsewrfsdfds=' +
						fdsewrfsdfds +
						'&hgfe5ty6hjtgft454tr=' +
						hgfe5ty6hjtgft454tr
					: '/assets/images/missing_avatar.gif'
			"
			[alt]="
				$safeNavigationMigration(dataObj?.name) +
				' ' +
				$safeNavigationMigration(dataObj?.title)
			"
			style="height: 75px; object-fit: contain"
		/>
	}
</div>

@if (dataObj) {
	<div class="guest-sched-container">
		<div class="user-details scheduler">
			<app-guest-user-details
				[dataObj]="dataObj"
				[saveObj]="saveObj"
				[fdsewrfsdfds]="fdsewrfsdfds"
				[hgfe5ty6hjtgft454tr]="hgfe5ty6hjtgft454tr"
			/>
		</div>

		@if (!eventsService.isMobile) {
			<div
				class="d-grid"
				style="gap: 30px"
			>
				<div
					class="scheduler"
					[hidden]="!meeting_request_with_calendar"
				>
					<h1>
						{{
							(dataObj?.meeting_request_with_calendar
								? "to_meeting_request"
								: "to_request_meeting_request"
							) | langVal
						}}
						<!--      {{dataObj.name}}-->
					</h1>
					<!--        <div style="padding-top:20px;">-->

					<div>
						<app-guest-hours-sched
							(chosenHourOut)="backFromHours($event)"
							[dataObj]="dataObj"
						/>
					</div>
				</div>

				<div class="scheduler">
					<div>
						<app-guest-add-meeting-form
							[saveObj]="saveObj"
							[dataObj]="dataObj"
							(backEv)="meeting_request_with_calendar = true"
							(saveOut)="hideNoCalendarTitle = true"
						/>
					</div>
				</div>
			</div>
		}
	</div>
}
@if (!hasApprovedCookies) {
	<div class="approve-cookies">
		<div class="box">
			<div>
				<h5>{{ "cookies_title" | langVal }}</h5>
				<div>{{ "cookies_text" | langVal }}</div>
				<div class="modal-btns">
					<button
						class="btn btn-default"
						(click)="isPrivacyOpen = true"
					>
						{{ "privacy_policy" | langVal }}
					</button>
					<button
						class="btn btn-primary"
						(click)="refuseCookies()"
					>
						{{ "refuse" | langVal }}
					</button>
					<button
						class="btn btn-primary"
						(click)="approveCookies()"
					>
						אישור
					</button>
				</div>
			</div>
		</div>
	</div>
}
@if (isPrivacyOpen) {
	<app-modal-wrap
		(onClose)="isPrivacyOpen = false"
		modalWrapperClass="modal-wide"
		hasExit
	>
		<app-privacy (onClose)="isPrivacyOpen = false" />
	</app-modal-wrap>
}
